import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
//import { PatientVaccines } from '../../../models/consultation-history/patient-vaccines.model';
//import { PatientVaccineSchedules } from '../../../models/consultation-history/patient-vaccine-schedules.model';
//import { PatientOtherVaccines } from '../../../models/consultation-history/patient-other-vaccines.model';
//import { DialogService } from '../../../shared/services/dialog.service';
//import { ConsultationHistoryService } from '../consultation-history.service';
import { AppConstants } from '../../shared/constants/constants';
import { VaccinationService } from './vaccination.service';
import { Utility } from '../../common/utility';

//import { AppConstants } from '../../../shared/constants/constants';
@Component({
    selector: 'ch-vaccination',
    templateUrl: 'vaccination.component.html',
    providers: [VaccinationService]
})

export class VaccinationComponent implements OnInit {    
    public vaccinationSchedules: any[];
    reload = false;
    public appConstants = AppConstants;
    public patientId = localStorage.getItem(this.appConstants.activeLink.userId);
    constructor(public utility: Utility,
        public vaccinationService: VaccinationService
    ) { }

    ngOnInit() {
        this.vaccinationSchedule(this.patientId);
    }

    vaccinationSchedule(patientConsultationId) {
        this.vaccinationService.vaccinationSchedules(this.patientId).subscribe(
            (result) => {
                if (result) {
                    this.vaccinationSchedules = result.json();
                    if (this.vaccinationSchedules.length) {
                        this.vaccinationSchedules.forEach(x => {
                            x.schedules.forEach(element => {
                                element.toolTipStr = element.siteToAdministerId ? 'Administered on ' +
                                    this.utility.convertDateToLocalString(new Date(element.vaccinateDate), 'DD-MMM-YYYY')
                                    + ' - By ' + element.administeredBy +
                                    ' - Batch No ' + element.batchNumber.toString() : 'Not Administered';
                            });
                        });
                    }
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/vaccination.component.ts